import { useDisclosure } from "@mantine/hooks"
import { ActionIconPlus } from "../../../../-components/action-icons"
import { CreateResourceObjectsModal } from "./CreateResourceObjectsModal"
import { ResourceTypeCategory } from "@/@client/Theasoft_DataClasses_Dispo"

interface Props {
  resourceId: number
  category: ResourceTypeCategory
}

export function CreateResourceObjectsActionIcon({
  resourceId,
  category,
}: Props) {
  const [opened, { open, close }] = useDisclosure()

  return (
    <>
      <ActionIconPlus onClick={open} />
      <CreateResourceObjectsModal
        opened={opened}
        onClose={close}
        defaultResourceId={resourceId}
        category={category}
      />
    </>
  )
}
